module.exports = __webpack_public_path__ + "img/png.b35d4fe9.svg";